var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row gap-x-1"},_vm._l((_vm.steps),function(index){return _c('div',{key:index,staticClass:"step",class:{ current: _vm.step >= index }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }